module.exports = __webpack_public_path__ + "static/tactics_collection_volejbal-1b3aa34d7bd5e2cdb3d4717a500c9032.mp4";